import ROSEATE from "@/assets/industry-co-led/partners/ROSEATE.png";
import MARRIOTT from "@/assets/industry-co-led/partners/MARRIOTT.png";
import NEPHROPLUS from "@/assets/industry-co-led/partners/NEPHROPLUS.png";
import EMVERSITY from "@/assets/industry-co-led/partners/EMVERSITY.png";
import REDVERSITY from "@/assets/industry-co-led/partners/REDVERSITY.png"
import logoRoseateAsset from "@/assets/bachelor-hospitality/JW_Marriott_Logo.png";
import logoJwMarriottAsset from "@/assets/bachelor-hospitality/Roseate_Logo.png";
import logoLeelaAsset from "@/assets/bachelor-hospitality/leela-logo.png";
import Img1 from "@/assets/industry-co-led/image/students.jpg"
import Img2 from "@/assets/industry-co-led/image/image-2.png"
import Img3 from "@/assets/industry-co-led/image/image-3.png"
import Img4 from "@/assets/industry-co-led/image/image-4.png"

export const ICL_UG_Programmes = {
  "categories": [
    "All",
    "JW Marriott | Roseate | The Leela",
    "Redversity",
    "Emversity",
    "Nephroplus",
    // "Marriott & Roseate"
  ],
  "programmes": [
    {
      "id": 1,
      "title": "Bachelor of Optometry",
      "category": "Emversity",
      "image": 'https://cdn.msu.edu.in/small_DSC_00555_1_1_32e0f68011.jpg',
      "poweredBy": EMVERSITY,
      "url": "/industry-co-led-ug-programmes/emversity/bachelor-of-optometry",
    },
    {
      "id": 2,
      "title": "Bachelor of Emergency Medical Technologist (Paramedic)",
      "category": "Emversity",
      "image": 'https://cdn.msu.edu.in/small_DSC_00373_1_532a10af8b.jpg',
      "poweredBy": EMVERSITY,
      "url": "/industry-co-led-ug-programmes/emversity/bachelor-of-emergency-medical-technologist-paramedic",
    },
    {
      "id": 3,
      "title": "Bachelor of Physiotherapy",
      "category": "Emversity",
      "image": 'https://cdn.msu.edu.in/small_DSC_00675_1_5308732449.jpg',
      "poweredBy": EMVERSITY,
      "url": "/industry-co-led-ug-programmes/emversity/bachelor-of-physiotherapy",
    },
    {
      "id": 4,
      "title": "Bachelor of Hospital Administration",
      "category": "Emversity",
      "image": 'https://cdn.msu.edu.in/small_ADP_7797_1_398464585e.jpg',
      "poweredBy": EMVERSITY,
      "url": "/industry-co-led-ug-programmes/emversity/bachelor-of-hospital-administration",
    },
    // {
    //   "id": 5,
    //   "title": "Bachelor of Physician Associates",
    //   "category": "Emversity",
    //   "image": Img3,
    //   "poweredBy": EMVERSITY,
    //   "url": "/industry-co-led-ug-programmes/emversity/bachelor-of-physician-associate-studies",
    // },
    {
      "id": 6,
      "title": "Bachelor of Medical Laboratory Science",
      "category": "Emversity",
      "image": 'https://cdn.msu.edu.in/small_ADP_7679_1_d2fcb8db2d.jpg',
      "poweredBy": EMVERSITY,
      "url": "/industry-co-led-ug-programmes/emversity/bachelor-of-medical-laboratory-science",
    },
    {
      "id": 7,
      "title": "UG Diploma in Emergency Medical Technology",
      "category": "Redversity",
      "image": Img1,
      "poweredBy": REDVERSITY,
      "url": "/industry-co-led-ug-programmes/redversity/diploma-in-emergency-medical-technology",
    },
    {
      "id": 8,
      "title": "BBA in Healthcare Management",
      "category": "Redversity",
      "image": Img2,
      "poweredBy": REDVERSITY,
      "url": "/industry-co-led-ug-programmes/redversity/bba-in-healthcare-management",
    },
    {
      "id": 9,
      "title": "Bachelor of Medical Radiology and Imaging Technology",
      "category": "Emversity",
      "image": 'https://cdn.msu.edu.in/small_DSC_00715_1_6d995bccf1.jpg',
      "poweredBy": EMVERSITY,
      "url": "/industry-co-led-ug-programmes/emversity/bachelor-of-medical-radiology-and-imaging-technology",
    },
    {
      "id": 10,
      "title": "Bachelor of Dialysis Therapy Technology",
      "category": "Emversity",
      "image": 'https://cdn.msu.edu.in/R_5_21755354c6.webp',
      "poweredBy": EMVERSITY,
      "url": "/industry-co-led-ug-programmes/emversity/bachelor-of-dialysis-therapy-technology",
    },
    {
      "id": 11,
      "title": "Bachelor of Nutrition and Dietetics",
      "category": "Emversity",
      "image": 'https://cdn.msu.edu.in/small_ADP_7801_1_08a87168b2.jpg',
      "poweredBy": EMVERSITY,
      "url": "/industry-co-led-ug-programmes/emversity/bachelor-of-nutrition-and-dietetics",
    },
    {
      "id": 12,
      "title": "Bachelor of Anaesthesia and Operation Theatre Technology",
      "category": "Emversity",
      "image": 'https://cdn.msu.edu.in/small_DSC_00454_1_bd0fe5be1d.jpg',
      "poweredBy": EMVERSITY,
      "url": "/industry-co-led-ug-programmes/emversity/bachelor-of-anesthesia-and-operation-theatre-technology",
    },
    {
      "id": 13,
      "title": "Bachelor of Dialysis Therapy Technology",
      "category": "Nephroplus",
      "image": 'https://cdn.msu.edu.in/student-training.webp',
      "poweredBy": NEPHROPLUS,
      "url": "/industry-co-led-ug-programmes/nephros/bachelor-of-dialysis-therapy-technology",
    },
    {
      "id": 14,
      "title": "Diploma in Dialysis Technology",
      "category": "Nephroplus",
      "image": 'https://cdn.msu.edu.in/small_RAH_6076_1_ecb8075310.jpg',
      "poweredBy": NEPHROPLUS,
      "url": "/industry-co-led-ug-programmes/nephros/diploma-in-dialysis-technology",
    },
    // {
    //   "id": 15,
    //   "title": "B.Sc. in Hospitality & Hotel Management",
    //   "category": "Marriott & Roseate",
    //   "image": Img2,
    //   "poweredBy": [MARRIOTT, ROSEATE],
    //   "url": "#",
    // }

    {
      "id": 16,
      "title": "B.Sc. in Hospitality & Hotel Management",
      "category": "JW Marriott | Roseate | The Leela",
      "image": 'https://cdn.msu.edu.in/Msu_Advantages_1_152f499ce5.jpg',
      "poweredBy": [MARRIOTT, ROSEATE],
      "url": "/industry-co-led-ug-programmes/iac/bsc-hospitality-hotel-management",
    }
  ]
}